import { Component, Injector, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { SecondPageEditBase } from 'vnpost-shared';
import { CategoryService } from '../../services/category.service';
import { ListTitleService } from '../../services/list-title.service';
import { JobTitleService } from '../../services/job-title.service';

@Component({
  selector: 'app-create-list-title',
  templateUrl: './create-list-title.component.html',
  styleUrls: ['./create-list-title.component.css'],
})
export class CreateListTitleComponent
  extends SecondPageEditBase
  implements OnInit
{
  listStatus: { label: string; value: number }[] = [
    { label: 'Đang áp dụng', value: 1 },
    { label: 'Ngừng áp dụng', value: 0 },
  ];

  note: any;
  listJobLevel: { label: string; value: string }[] = [];
  levelId: string = '';
  currentUnitCode: any = '00';
  listTitle: { label: string; value: number }[] = [];
  titleId: [] = [];

  constructor(
    protected _listTileService: ListTitleService,
    protected _jobTitleService: JobTitleService,
    protected _injector: Injector
  ) {
    super(_listTileService, _injector);
    this.currentUnitCode = this.currentUser?.unitCode;
    this.formGroup = new UntypedFormGroup({
      levelId: new UntypedFormControl('', [Validators.required]),
      titleId: new UntypedFormControl('', [Validators.required]),
      commissionRate: new UntypedFormControl('', [Validators.required]),
      status: new UntypedFormControl(''),
      notes: new UntypedFormControl(''),
    });
  }

  ngOnInit() {
    this.getLevel();
  }

  onShowPopup() {
    this.validationSummary.resetErrorMessages();
    this.resetForm();
    this.onReset();

    this.itemDetail.id = 0;
    this.itemDetail.status = 1;
  }

  async save() {
    if (this.titleId.length === 0) {
      this._notifierService.showWarning('Vui lòng chọn tên chức danh');
      return;
    }

    if (this.formGroup.invalid) {
      this.validationSummary.showValidationSummary();
      return;
    }
    this.submitting = true;
    const model = {
      unitCode: this.currentUnitCode,
      jobTitleIdList: this.titleId,
      commissionRate: this.itemDetail.commissionRate,
      status: this.itemDetail.status,
      notes: this.itemDetail.notes,
    };

    this._listTileService
      .create(model)
      .then(
        (response) => {
          this.closePopupMethod(true);
          this._notifierService.showInsertDataSuccess();
          this.onAfterSave();
          this.submitting = false;
        },
        (error) => {
          this._notifierService.showError(
            'Thêm mới thất bại: ' + error.error.message
          );
          this.submitting = false;
        }
      )
      .finally(() => {
        this.submitting = false;
        this.levelId = '';
        this.listTitle = [];
        this.titleId = [];
      });
  }

  onInsert() {
    this._listTileService.create(this.itemDetail).then(
      (response) => {
        this.closePopupMethod(true);
        this._notifierService.showInsertDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      },
      (error) => {
        this._notifierService.showInsertDataFailed();
        this.submitting = false;
      }
    );
  }

  getLevel() {
    this._jobTitleService.getLevel({}).then((res) => {
      this.listJobLevel = res?.data?.map((r) => ({
        label: r.levelName,
        value: r.levelId,
        leaf: false,
      }));
    });
  }

  changeLevel(event: any) {
    const model = {
      levelId: this.levelId,
      unitCode: this.currentUnitCode,
    };
    this.listTitle = [];
    this._jobTitleService.getAll(model).then((res) => {
      this.listTitle = res?.data?.map((r) => ({
        label: r.id + ' - ' + r.name,
        value: r.id,
        leaf: false,
      }));
    });
  }
}
